<div class="row" *ngIf="Breadcrumblist!=null">
  <div class="col-12 p-0 border-bottom headersize">
    <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
  </div>
</div>
  <div class="col-12">
    <div class="row pt-2">
      <div class="col-12 text-right pr-0 pt-1 pl-0">
        <div class="d-flex">
          <div class="p-0">Question Number&nbsp;:&nbsp;{{selectedQuestionById.Question_ID}} </div>
        </div>
      </div>
      <!-- <div class="col-10 pl-2 pr-0">
        <input type="text" class="form-control form-control-sm input-txt" [(ngModel)]="selectedQuestionById.Question_ID" readonly />
      </div> -->
    </div>
  </div>
  <!-- <div class="row pt-3">
    <div class="col-12">
      <div class="p-1 scroll-style px-1 border">
        <div class="d-flex border-bottom">
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">No.</div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-2">Date</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-2">Status</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-2">Changed By</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-1">Date and Time</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-1">Comments</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 Rl-hdr pt-1 pb-1">
            <p class="Rl-col-1">Reasons</p>
          </div>
        </div>
  
        <div class="d-flex invRow" 
          *ngFor="let s of QuestionStatusList; let i = index">
          <div class="px-1 text-right pt-1 pb-1  border-bottom">{{i+1}}
            </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
             <p class="Rl-col-2">{{s.Status_Created_Date | date: "dd-MMM-yyyy"}}</p> 
             
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-2">{{s.Status_Name}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-2">{{s.Status_Created_By}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.Status_Created_Date | date:'medium'}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.Status_Comment_Text}}</p>
          </div>
          <div class="px-1 text-left pt-1 pb-1 border-bottom">
            <p class="Rl-col-1">{{s.Review_Action_Reasons}}</p>
          </div>

        </div>
  
        <div class="d-flex" *ngIf="!QuestionStatusList">
          <div class="p-3 m-3">No search results</div>
        </div>
  
      </div>
    </div>
    </div> -->
    <div class="row pt-3">
      <div class="col-12">
          <div class="row pt-1">
              <div class="col-12 scroll-style">
                <table class="table table-bordered table-responsive">
                  <thead>
                    <tr class="table-secondary">
                      <th  class="col-md-1 centertext" style="width: 3%;">No.</th>
                      <th  class="col-md-1 centertext">Date</th>
                      <th  class="col-md-1 centertext">Status</th>
                      <th class="col-md-1 centertext">Changed By</th>
                      <th  class="col-md-1 centertext">Date and Time</th>
                      <th  class="col-md-1 centertext">Comments</th>
                      <th  class="col-md-1 centertext">Reasons</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of QuestionStatusList;let i=index">
                      <td  class="centertext">{{i+1}}</td>
                      <td  class="centertext">{{s.Status_Created_Date | date: "dd-MM-yy"}}</td>
                      <td  class="centertext">{{s.Status_Name}}</td>
                      <td  class="centertext">{{s.Status_Created_By}}</td>
                      <td  class="centertext">{{s.Status_Created_Date | date:"dd-MM-yy"}}</td>
                      <td class="centertext">{{s.Status_Comment_Text}}</td>
                      <td class="centertext">{{s.Review_Action_Reasons}}</td>
                      
                    </tr>
                  </tbody>
                </table>
                <div class="col-12">
                  <div class="d-flex justify-content-center pt-1 pb-1">
                    
                    <div class="px-1">
                      <button type="button" class="btn btn-sm bg-light border" (click)="CloseStatusPopup()">Close</button>
                     
                    </div>
                  </div>
                </div>
                
        
        </div>
      
      </div>
  
      </div>
     
    
  
  </div>
<!-- <div class="row">
  <div class="col-12">
    <div class="d-flex justify-content-center pt-1 pb-1">
      <div class="px-1">
        <button type="button"  class="btn btn-sm bg-light border" (click)="CloseStatusPopup()">Close</button>
      </div>
    </div>
  </div>
</div> -->